module.exports = __webpack_public_path__ + "img/aboutApp5.00addcf2.png";